module.exports = __webpack_public_path__ + "img/暴雨.1d85aab4.png";